export default "__VITE_ASSET__77pdO_I6__"